module.exports = __webpack_public_path__ + "static/media/Video3.783bc9c2.mp4";